import React from "react";
import OptionRow from "./OptionRow";
import OtherOptionRow from "./OtherOptionRow";

export default function ChoiceStep({
  answers,
  canContinue,
  canGoBack,
  failed,
  onBack,
  onContinue,
  onOtherTextChange,
  onToggleOption,
  onToggleOther,
  options,
  otherChecked,
  otherLabel,
  otherText,
  otherTextMax,
  question,
  selectionCount,
  submitting
}) {
  const atMax = question.maxChoices != null && selectionCount >= question.maxChoices;
  const disabledUnselected = (selected) => !selected && (atMax || submitting);

  return (
    <div className="survey-step">
      <h2 className="survey-headline">{question.headline}</h2>
      {question.explanation && (
        <p className="survey-explanation">{question.explanation}</p>
      )}
      <div className="survey-options">
        {options.map((option) => (
          <OptionRow
            checked={answers.includes(option)}
            disabled={disabledUnselected(answers.includes(option))}
            key={option}
            label={option}
            onToggle={() => onToggleOption(option)}
          />
        ))}
        {question.allowOther && (
          <OtherOptionRow
            checked={otherChecked}
            disabled={disabledUnselected(otherChecked)}
            label={otherLabel}
            maxLength={otherTextMax}
            onTextChange={onOtherTextChange}
            onToggle={onToggleOther}
            text={otherText}
          />
        )}
      </div>
      {failed && (
        <p className="survey-error">Sorry, something went wrong. Please try again.</p>
      )}
      {question.multiple && (
        <div className="survey-actions">
          {canGoBack && (
            <button className="survey-back joystix" disabled={submitting} onClick={onBack} type="button">
              Back
            </button>
          )}
          <button
            className="survey-continue joystix"
            disabled={!canContinue || submitting}
            onClick={onContinue}
            type="button"
          >
            Continue
          </button>
        </div>
      )}
    </div>
  );
}
